<template>
  <div class="main">
    <headerBar current="solution?index=1"></headerBar>
    <div class="swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/banner1.png" alt="">
            <div class="content">
              <h3>多式联运项目开发及运营</h3>
              <p>国内、国际多式联运的项目组织集成化、可视化服务</p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../assets/banner2.png" alt="">
            <div class="content">
              <h3>自备车（箱）资产运营</h3>
              <p>以铁路自备车和自备箱资产动态运营为主的数字化服务</p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../assets/banner3.png" alt="">
            <div class="content">
              <h3>业财务结算统计自动化</h3>
              <p>项目客户及供应商结算数据的自动化提取与统计、呈现服务</p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../assets/banner4.png" alt="">
            <div class="content">
              <h3>场站及园区运营智能化</h3>
              <p>
                货运代理、场站服务、资产租赁等企业与上下游企业协同线上化
              </p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../assets/banner5.png" alt="">
            <div class="content">
              <h3>平台应用开放API服务</h3>
              <p>为环铁路多式联运企业自主研发的物流及供应链管理系统，提供与铁路运输方式相关的数据采集、分析处理的技术对接、技术咨询和运维支持。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination" slot="pagination"></div>
    </div>
    <div class="tab">
      <p :class="current == 1 ? 'on' : ''" @click="tabBtn(1)">多式联运项目开发及运营</p>
      <p :class="current == 2 ? 'on' : ''" @click="tabBtn(2)">自备车（箱）资产运营</p>
      <p :class="current == 3 ? 'on' : ''" @click="tabBtn(3)">业财务结算统计自动化</p>
      <p :class="current == 4 ? 'on' : ''" @click="tabBtn(4)">场站及园区运营智能化</p>
      <p :class="current == 5 ? 'on' : ''" @click="tabBtn(5)">平台应用开放API服务</p>
    </div>
    <div class="con" v-if="current == 1">
      <div class="title">客户价值</div>
      <div class="tip">
        <div>基于联运物流项目履约中的计划、发运、跟踪、派送、交付、费用结算统计与单据归集的全流程服务。发运站的箱（车）可用资源查询，项目履约各阶段的线上化操作与可视化的管理服务。</div>
      </div>
      <div class="title">功能介绍</div>
      <div class="introduce">
        <ul>
          <li>
            <div>
              <h3>多式联运物流项目发运动态及运踪查询（支持公铁海全程运踪）</h3>
              <p>实时掌握项目的批量运踪信息，协助企业安排作业计划，提高作业效率。</p>
            </div>
            <img src="../assets/pic1.png" alt="" />
            <img src="../assets/pic1.1.png" alt="" />
          </li>
          <li>
            <div>
              <h3>国内、国际项目集成化管理</h3>
              <p>国内、国际联运项目履约过程可视化管理，动态呈现相关车站及口岸站俄车数量和位置、发运吨数，入境日期、换装中车等装状态变化情况。</p>
            </div>
            <img src="../assets/pic4.png" alt="" />
          </li>
          <li>
            <div>
              <h3>物流项目批量运踪查询</h3>
              <p>实时查看批量运踪，发运、在途、到达车辆线上可视化管理。</p>
            </div>
            <img src="../assets/pic5.png" alt="" />
          </li>
          <li>
            <div>
              <h3>物流项目履约管理</h3>
              <p>展示物流项目的发运统计台账，使生产运营人员可以及时掌握当日请车受理情况、单日装车、累计装车数和发运吨数等情况。</p>
            </div>
            <img src="../assets/pic6.png" alt="" />
          </li>
          <li>
            <div>
              <h3>多联产品线路开发</h3>
              <p>整合铁路/公路/海运等多种运输方式，提供“东北地区至东南沿海的铁海联运产品开发、经满洲里或绥芬河口岸的跨境铁路联运集货分拨服务和一单制全程运营托管”等开发及运营服务。</p>
            </div>
            <img src="../assets/pic25.png" alt="" />
          </li>
          <li>
            <div>
              <h3>产品辅助开发</h3>
              <p>为客户提供一站式多式联运解决方案，涵盖铁海/海铁/公铁海等定制化方案的联运产品设计、需求分析至平台部署的智能系统开发及全程运营支持，实现从规划到落地的全周期服务闭环。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="con" v-if="current == 2">
      <div class="title">客户价值</div>
      <div class="tip">
        <div>对客户的自备车（箱）资产的空间位置分布、运用状态构成、承运信息进行关联、呈现，包括动态的明细信息和分类的统计输出，实现企业物流运力资产的可视化运营管理。</div>
      </div>
      <div class="title">功能介绍</div>
      <div class="introduce">
        <ul>
          <li>
            <div>
              <h3>自备车（箱）运用情况统计</h3>
              <p>根据用户关切指标展示自备箱（车）的统计数据和资产运用状态结构性占比分析，对资产总体运营情况一目了然，实现企业运力资产的可视化运营管理。</p>
            </div>
            <img src="../assets/pic7.png" alt="" />
          </li>
          <li>
            <div>
              <h3>自备车（箱）动态及历史运行轨迹查询</h3>
              <p>实时查询车（箱）当前承运及历史运行的轨迹信息，支持按时间区段和车（箱）号单独搜索查询。</p>
            </div>
            <img src="../assets/pic8.png" alt="" />
          </li>
          <li>
            <div>
              <h3>自备车（箱）批量实时动态信息采集与呈现</h3>
              <p>对自备车（箱）物流资产的实时动态运营相关信息进行采集和呈现，根据客户项目动态发收货统计的需要，生成相关的专题报表（支持导出），辅助生产运营组织调度和业务数据分析。</p>
            </div>
            <img src="../assets/pic9.png" alt="" />
          </li>
          <li>
            <div>
              <h3>自备车（箱）动态分布明细与统计</h3>
              <p>可按发站、到站实时查询自备车（箱）物流资产的动态分布明细，并进行结构性占比统计。</p>
            </div>
            <img src="../assets/pic10.png" alt="" />
            <img src="../assets/pic10.1.png" alt="" />
          </li>
          <li>
            <div>
              <h3>自备车（箱）装运费用查询</h3>
              <p>可按时间、运单号实时查询自备车（箱）装车费用，辅助企业进行结算费用统计与分析。</p>
            </div>
            <img src="../assets/pic11.png" alt="" />
          </li>
          <li>
            <div>
              <h3>自备车（箱）周转率统计</h3>
              <p>支持分别按车辆和车型进行周转率统计，动态呈现综合周转率和平均周转率，辅助企业提高资产运用效率。</p>
            </div>
            <img src="../assets/pic12.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <div class="con" v-if="current == 3">
      <div class="title">客户价值</div>
      <div class="tip">
        <div>联运物流项目的收入、货量、工作量、采购支出、资金预（垫）付等单据的动态归集、统计与核对，实现对账结算自动化、可视化操作管理，提高业财协同效率。</div>
      </div>
      <div class="title">功能介绍</div>
      <div class="introduce">
        <ul>
          <li>
            <div>
              <h3>物流项目装车数据统计</h3>
              <p>可实时查看年度、月度累计装车数量和装运吨数及明细，为线上结算自动化提供数据支撑。</p>
            </div>
            <img src="../assets/pic13.png" alt="" />
          </li>
          <li>
            <div>
              <h3>供应商采购支出对账单</h3>
              <p>配置不同供应商采购单价，根据业务发生数据，自动生成供应商对账单及明细，实现无纸化对账，提高工作效率。</p>
            </div>
            <img src="../assets/pic14.png" alt="" />
          </li>
          <li>
            <div>
              <h3>客户销售收入对账单</h3>
              <p>配置结算单价、结算单元，根据实际运营生产数据、结算区间，自动生成客户对账单及明细，实现无纸化对账，提高工作和沟通效率。</p>
            </div>
            <img src="../assets/pic15.png" alt="" />
          </li>
          <li>
            <div>
              <h3>物流项目铁路预存运费资金动态余额管理</h3>
              <p>与铁路便捷对账，铁路预存款余额、实扣款、应扣款金额及明细实时查询。</p>
            </div>
            <img src="../assets/pic16.png" alt="" />
            <img src="../assets/pic16.1.png" alt="" />
          </li>
          <li>
            <div>
              <h3>业财核销管理</h3>
              <p>打通移动端OA线上审批流程，报销、付款线上可视化操作、审批，实现对账结算自动化、提高业财协同效率。</p>
            </div>
            <img src="../assets/pic17.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <div class="con" v-if="current == 4">
      <div class="title">客户价值</div>
      <div class="tip">
        <div>发挥数字化服务优势，打通产业链上下游，促进全供应链流程的数字化协同，解决客户服务响应速度慢、响应周期长等问题，让上下游企业享受数字化的便捷服务，提升上下游响应服务效率。</div>
      </div>
      <div class="title">功能介绍</div>
      <div class="introduce">
        <ul>
          <li>
            <div>
              <h3>客户委托物流项目执行情况统计与反馈</h3>
              <p>计划发运情况与实际发运情况线上查询，替代通过表格、微信等手工传递数据的传统作业方式，提升沟通与数据流转效率。</p>
            </div>
            <img src="../assets/pic18.png" alt="" />
          </li>
          <li>
            <div>
              <h3>客户应付款统计及明细</h3>
              <p>通过项目实际发运量与明细统计自动生成客户应付款对账单及明细，方便客户线上实现对账确认。</p>
            </div>
            <img src="../assets/pic19.png" alt="" />
            <img src="../assets/pic19.1.png" alt="" />
            <img src="../assets/pic19.2.png" alt="" />
          </li>
          <li>
            <div>
              <h3>供应商物流项目受理装运及明细</h3>
              <p>实时动态查询各个供应商请批车、装运数据统计，实现上线可视化履约过程监测。</p>
            </div>
            <img src="../assets/pic20.png" alt="" />
          </li>
          <li>
            <div>
              <h3>供应商应收款统计及明细</h3>
              <p>通过项目实际发运量与明细统计自动生成供应商应收款对账单及明细，方便供应商线上实现对账确认。</p>
            </div>
            <img src="../assets/pic21.png" alt="" />
            <img src="../assets/pic21.1.png" alt="" />
          </li>
          <li>
            <div>
              <h3>场站管家运营管理</h3>
              <p>实现场站作业资源的数字化映射与实时监控，展示场外箱、场存箱等实时数量与分布状态，通过三维可视化界面直观呈现设备状态。</p>
              <img src="../assets/pic24.png" alt="" />
              <img src="../assets/pic24.1.png" alt="" />
            </div>
          </li>
          <li>
            <div>
              <h3>资产租赁周转率统计与明细查询</h3>
              <p>支持按租赁的权属单位统计车（箱）资产运营情况，实时查询车（箱）周转率与明细。</p>
            </div>
            <img src="../assets/pic22.png" alt="" />
            <img src="../assets/pic22.1.png" alt="" />
          </li>
          <li>
            <div>
              <h3>资源发布与受理</h3>
              <p>支持通过平台发布物流服务相关需求（货源、车源、箱源），提升闲置资源利用率。</p>
            </div>
            <img src="../assets/pic23.png" alt="" />
            <img src="../assets/pic23.1.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <div class="con" v-if="current == 5">
      <div class="title">客户价值</div>
      <div class="tip">
        <div class="linemin">联运通应用开放接口服务（MTS-API），目的是为多式联运企业自主搭建的物流及供应链管理平台提供多样的铁路运输相关数据的采集能力，帮助企业构建自己的多接口多渠道应用平台，通过联运通轻量级API服务工具，充分降低企业人工线下沟通，线上录入的多环节操作成本，实现数据应用服务于生产的高效转换。</div>
      </div>
      <div class="title">功能介绍</div>
      <div class="introduce">
        <ul>
          <li>
            <div>
              <h3>多式联运全程运踪类服务</h3>
              <h3>授权认证</h3>
              <p>通过联运管家官网（www.56links.com）-联系我们，线上对接取得API服务授权，获得授权编码或定制链接。</p>
              <h3>服务项点</h3>
              <p>铁路全程运踪轨迹接口。</p>
              <p>作用：授权用户的国内铁路货物运输的运踪及状态查询。</p>
              <p>具体需求可与商务对接，以实际业务属性规格为主。</p>
            </div>
          </li>
          <li>
            <div>
              <h3>铁路运单及上下游结算类服务</h3>
              <h3>授权认证</h3>
              <p>通过联运管家官网（www.56links.com）-联系我们，线上对接取得API服务授权，获得授权编码或定制链接。</p>
              <h3>服务项点</h3>
              <p>（1）铁路电子运单接口</p>
              <p>作用：授权用户的国内铁路货物运输的运单及状态查询。</p>
              <p>（2）企业铁路预存运费资金动态接口</p>
              <p>作用：授权用户的铁路预存款及发货抵用情况查询。</p>
              <p>（3）联运通平台服务对账接口</p>
              <p>作用：授权对账服务集成开发的技术支持与上线陪跑服务。</p>
              <p>（4）供应商业务结算接口</p>
              <p>作用：提供运输数据查询及供应商对账技术支持与上线陪跑服务。</p>
              <p>（5）客户业务结算接口</p>
              <p>作用：提供运输数据查询及客户对账技术支持与上线陪跑服务。</p>
              <p>具体需求可与商务对接，以实际业务属性规格为主。</p>
            </div>
          </li>
          <li>
            <div>
              <h3>项目运输组织类服务</h3>
              <h3>授权认证</h3>
              <p>通过联运管家官网（www.56links.com）-联系我们，线上对接取得API服务授权，获得授权编码或定制链接。</p>
              <h3>服务项点</h3>
              <p>（1）铁路运输阶段需求受理接口</p>
              <p>作用：授权账户铁路阶段承运服务受理情况查询。</p>
              <p>（2）铁路装车日计划接口</p>
              <p>作用：授权账户铁路日请车计划受理情况查询。</p>
              <p>（3）海关单一窗口接口</p>
              <p>作用：进出口业务电子化办理进度查询。</p>
              <p>（4）海运订舱接口</p>
              <p>作用：查询海运航线产品及预定舱位信息。</p>
              <p>（5）汽运派接单接口</p>
              <p>作用：查询汽运车辆派单及接单数据。</p>
              <p>（6）公铁海全程运踪接口</p>
              <p>作用：查询货物多式联运全程运踪信息。</p>
              <p>具体需求可与商务对接，以实际业务属性规格为主。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <contact></contact>
    <footerBar></footerBar>
  </div>
</template>

<script>
import headerBar from "../components/headerBar"
import contact from "../components/contact"
import footerBar from "../components/footerBar"
import Swiper from "swiper"
import "swiper/dist/css/swiper.css"
export default {
  name: "solution",
  components: { headerBar, contact, footerBar },
  data() {
    return {
      current: 1,
      swiper: ''
    }
  },
  mounted() {
    let that = this
    this.swiper = new Swiper(".swiper-container", {
      speed: 500,
      loop: true,
      initialSlide: this.$route.query.index - 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        slideChange() {
          if (this.activeIndex > 5) {
            that.current = 1
          } else if (this.activeIndex < 1) {
            that.current = 5
          } else {
            that.current = this.activeIndex
          }
        }
      }
    });
    this.current = this.$route.query.index
  },
  methods: {
    tabBtn(index) {
      this.current = index;
      this.swiper.slideTo(index)
    }
  },
  watch: {
    $route(e) {
      this.current = e.query.index;
      this.swiper.slideTo(this.current)
    }
  },
};
</script>

<style scoped>
@media screen and (min-width: 1025px) {
  .swiper {
    margin-top: 0.7rem;
    position: relative;
  }

  .swiper .swiper-slide img {
    width: 19.2rem;
    position: absolute;
    top: 0;
    left: 0;
  }

  .swiper .swiper-slide .content {
    height: 4.65rem;
    position: relative;
    z-index: 9;
    width: 13rem;
    margin: 0 auto;
    padding-top: 0.9rem;
  }

  .swiper .swiper-slide h3 {
    font-size: 0.44rem;
    color: #fff;
    font-weight: bold;
  }

  .swiper .swiper-slide p {
    color: #fff;
    font-size: 0.18rem;
    margin-top: 0.54rem;
  }

  .swiper .swiper-pagination {
    width: 13rem;
    bottom: 1rem;
    left: 50%;
    margin-left: -6.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .swiper .swiper-pagination >>> span {
    width: 0.5rem;
    height: 0.08rem;
    background: #fff;
    border-radius: 0.04rem;
    margin: 0 0.05rem;
  }

  .tab {
    width: 13rem;
    margin: 0.2rem auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .tab p {
    padding: 0 0.2rem;
    line-height: 0.5rem;
    font-size: 0.18rem;
    color: #091c2e;
    border: 1px solid #091c2e;
    cursor: pointer;
  }

  .tab p.on {
    background: #1070ff;
    border-color: #1070ff;
    color: #fff;
  }

  .con {
    margin-top: 0.3rem;
  }

  .con .title {
    padding-top: 0.4rem;
    font-size: 0.48rem;
    color: #091c2e;
    text-align: center;
    font-weight: bold;
  }

  .con .tip {
    height: 2rem;
    margin-top: 0.2rem;
    background: url("../assets/pc/tip.png") no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .con .tip div {
    width: 13rem;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #091c2e;
    line-height: 0.3rem;
  }

  .con .introduce {
    width: 13rem;
    margin: 0 auto;
  }

  .con .introduce ul li {
    padding-top: 0.6rem;
  }

  .con .introduce ul li div {
    padding-left: 0.6rem;
    background: url("../assets/pc/icon-explain.png") no-repeat left 0.1rem;
    background-size: 0.36rem;
  }

  .con .introduce ul li div h3 {
    font-size: 0.22rem;
    color: #091c2e;
    font-weight: bold;
    line-height: 0.6rem;
  }

  .con .introduce ul li div p {
    font-size: 0.18rem;
    color: #656d75;
    line-height: 0.4rem;
  }

  .con .introduce ul li h4 {
    border: 1px solid #ddd;
    padding: 0.2rem;
    font-size: 0.14rem;
    color: #666;
    margin-top: 0.2rem;
  }

  .con .introduce ul li h4 i {
    font-size: 0.16rem;
    color: green;
  }

  .con .introduce ul li img {
    width: 7.46rem;
    display: block;
    margin: 0.5rem auto 0;
  }

  .con .introduce ul li img + img {
    margin: 0 auto;
  }
}

@media screen and (max-width: 1024px) {
  .swiper {
    margin-top: 1rem;
    position: relative;
    overflow: hidden;
  }

  .swiper .swiper-slide {
    overflow: hidden;
  }

  .swiper .swiper-slide img {
    width: 19.2rem;
    position: absolute;
    top: 0;
    left: -2rem;
  }

  .swiper .swiper-slide .content {
    height: 4.6rem;
    padding: 1.6rem 0.4rem 0;
    position: relative;
    z-index: 9;
  }

  .swiper .swiper-slide h3 {
    font-size: 0.48rem;
    color: #fff;
    font-weight: bold;
    font-family: LiShu;
  }

  .swiper .swiper-slide p {
    color: #fff;
    font-size: 0.22rem;
    margin-top: 0.14rem;
    font-family: SongTi;
  }

  .swiper .swiper-pagination {
    width: 100%;
    bottom: 0.1rem;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper .swiper-pagination >>> span {
    width: 0.3rem;
    height: 0.06rem;
    background: #fff;
    border-radius: 0.03rem;
    margin: 0 0.1rem;
  }

  .tab {
    display: none;
  }

  .con {
    margin: 0.2rem 0 0.6rem;
  }

  .con .title {
    padding-top: 0.7rem;
    font-size: 0.34rem;
    color: #091c2e;
    text-align: center;
    font-weight: bold;
  }

  .con .tip {
    height: 3.2rem;
    padding: 0 0.8rem;
    background: url("../assets/mobile/tip.png") no-repeat left bottom;
    background-size: 100%;
    display: flex;
    align-items: center;
    border-radius: 0.26rem;
    box-shadow: 0 6px 11px 0 rgba(5, 0, 0, 0.1);
  }

  .con .tip div {
    font-size: 0.26rem;
    color: #595959;
    line-height: 0.5rem;
    text-indent: 2em;
  }

  .con .tip div.linemin {
    line-height: normal;
  }

  .con .introduce {
    padding: 0 0.2rem;
    background: url("../assets/mobile/circular-bg.png") no-repeat left top,
      url("../assets/mobile/service-bg.png") no-repeat right 5.5rem,
      url("../assets/mobile/introduce-bg.png") no-repeat left 25.4rem;
    background-size: 2.4rem, 4.2rem, 3.9rem;
  }

  .con .introduce ul li {
    padding: 0.3rem 0;
    border-bottom: 1px solid #dcdcdc;
  }

  .con .introduce ul li div {
    background: url("../assets/mobile/icon-explain.png") no-repeat left 0.1rem;
    background-size: 0.3rem;
  }

  .con .introduce ul li div h3 {
    font-size: 0.28rem;
    color: #091c2e;
    font-weight: bold;
    line-height: 0.6rem;
    padding-left: 0.48rem;
  }

  .con .introduce ul li div p {
    font-size: 0.24rem;
    color: #656d75;
    text-indent: 2em;
    line-height: 0.4rem;
  }

  .con .introduce ul li h4 {
    border: 1px solid #ddd;
    padding: 0.2rem;
    font-size: 0.14rem;
    color: #666;
    margin-top: 0.2rem;
  }

  .con .introduce ul li h4 i {
    font-size: 0.16rem;
    color: green;
  }

  .con .introduce ul li img {
    width: 100%;
    display: block;
    margin-top: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution.vue